module.exports = "/virtual-football-league/img/amblems/left/logos/Lazio.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Lazio.png
// module id = 2101
// module chunks = 4